<template>
  <el-dialog v-dialogDrag title="邀请好友" :visible.sync="show" width="620px" :before-close="close">
    <div class="add-group-member">
      <div class="left-box">
        <el-input placeholder="搜索好友" v-model="searchText" size="small">
          <i class="el-icon-search el-input__icon" slot="suffix"> </i>
        </el-input>
        <el-scrollbar style="height:400px;">
          <div v-for="friend in friends" :key="friend.id">
            <friend-item v-show="friend.showNickName.includes(searchText)" @click.native="onSwitchCheck(friend)"
              :menu="false" :friend="friend" size="small">
              <el-checkbox :disabled="friend.disabled" @click.native.stop="" class="checkbox"
                v-model="friend.isCheck"></el-checkbox>
            </friend-item>
          </div>
        </el-scrollbar>
      </div>
      <div class="arrow el-icon-d-arrow-right"></div>
      <div class="right-box">
        <div class="tip"> 已勾选{{ checkCount }}位好友</div>
        <el-scrollbar style="height:400px;">
          <div v-for="friend in friends" :key="friend.id">
            <friend-item v-if="friend.isCheck && !friend.disabled" :friend="friend" size="small"
              @del="onRemoveFriend(friend)" :menu="false">
            </friend-item>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close()">取 消</el-button>
      <el-button type="primary" :loading="submitting" @click="onOk()">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import FriendItem from '../friend/FriendItem.vue';

export default {
  name: "addGroupMember",
  components: {
    FriendItem
  },
  data() {
    return {
      show: false,
      searchText: "",
      friends: [],
      submitting: false
    }
  },
  methods: {
    open() {
      this.show = true;
      this.friends = [];
      this.friendStore.friends.forEach((f) => {
        if (f.deleted) {
          return;
        }
        let friend = JSON.parse(JSON.stringify(f))
        let m = this.members.filter((m) => !m.quit).find((m) => this.getAccountId(m) == this.getAccountId(f));
        if (m) {
          // 好友已经在群里
          friend.disabled = true;
          friend.isCheck = true
        } else {
          friend.disabled = false;
          friend.isCheck = false;
        }
        this.friends.push(friend);
      })
    },
    close() {
      this.show = false;
    },
    async onOk() {
      let inviteeAccountIds = []
      this.friends.forEach((f) => {
        if (f.isCheck && !f.disabled) {
          inviteeAccountIds.push(this.getAccountId(f));
        }
      })
      inviteeAccountIds = [...new Set(inviteeAccountIds.filter(Boolean).map(id => String(id)))];
      if (!inviteeAccountIds.length) {
        this.$message.warning("请选择要邀请的好友");
        return;
      }
      this.submitting = true;
      try {
        const failedAccountIds = await this.$yunxinIM.inviteTeamMembers(
          this.groupId,
          this.teamType,
          inviteeAccountIds,
          this.postscript
        );
        const failedCount = failedAccountIds.length;
        const successCount = inviteeAccountIds.length - failedCount;
        if (successCount > 0) {
          this.$message.success(`已邀请${successCount}位好友`);
          const invitedNames = this.friends
            .filter(f => f.isCheck && !f.disabled && inviteeAccountIds.includes(String(this.getAccountId(f))))
            .map(f => f.showNickName || f.nickName || this.getAccountId(f));
          this.$emit("operation-message", `你邀请${invitedNames.join('、')}加入群聊`);
          this.$emit("reload");
          this.close();
        }
        if (failedCount > 0) {
          this.$message.warning(`${failedCount}位好友邀请失败`);
        }
      } catch (error) {
        console.error('[AddGroupMember] 邀请群成员失败:', error);
        this.$message.error(error?.message || "邀请失败");
      } finally {
        this.submitting = false;
      }
    },
    getAccountId(item = {}) {
      return item.accountId || item.imAccid || item.userId || item.id;
    },
    onRemoveFriend(friend) {
      friend.isCheck = false;
    },
    onSwitchCheck(friend) {
      if (!friend.disabled) {
        friend.isCheck = !friend.isCheck
      }
    }
  },
  props: {
    groupId: {
      type: [Number, String]
    },
    members: {
      type: Array
    },
    teamType: {
      type: Number,
      default: 1
    },
    postscript: {
      type: String,
      default: ''
    }
  },
  computed: {
    checkCount() {
      return this.friends.filter((f) => f.isCheck && !f.disabled).length;
    }
  }
}
</script>

<style lang="scss" scoped>
.add-group-member {
  display: flex;

  .left-box {
    flex: 1;
    overflow: hidden;
    border: var(--im-border);

    .checkbox {
      margin-right: 10px;
    }
  }

  .arrow {
    display: flex;
    align-items: center;
    font-size: 18px;
    padding: 10px;
    color: var(--im-color-primary);
  }

  .right-box {
    flex: 1;
    border: var(--im-border);

    .tip {
      text-align: left;
      height: 32px;
      line-height: 32px;
      text-indent: 10px;
      color: var(--im-text-color-light)
    }
  }
}
</style>
